import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect } from 'react'
import { fetchPopularSkills } from '../../redux/searchSlice'
import useDebounce from '../../hooks/useDebounce'
import { useDispatch } from 'react-redux'

const SearchSkills = ({ skillName, setSkillName}) => {

    const dispatch = useDispatch()
    
    const { debouncedValue } = useDebounce(skillName)

    useEffect(() => {
        if(debouncedValue){
            dispatch(fetchPopularSkills({ searchValue: debouncedValue }))
        }
    }, [debouncedValue, dispatch])

    const resetDebouncedValue = () => setSkillName('')

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <div>
            <form className='flex flex-col' onSubmit={handleSubmit}>
                <div className='relative w-full'>
                    <div className='absolute inset-y-0 left-0 pl-3 flex items-center'>
                        <FontAwesomeIcon icon={faSearch} className={`text-white/50 text-lg`}/>
                    </div>
                    <div className='w-full flex'>
                        <input 
                            type="text"
                            value={skillName}
                            onChange={(e) => setSkillName(e.target.value)}
                            tabIndex={-1}
                            placeholder='Search for any skill you want'
                            className={`w-full p-2.5 h-[45px] text-sm font-medium pl-10 skill_search rounded-lg bg-bg-13/[15%] outline-0 border-0 placeholder:text-sm placeholder:font-medium placeholder:text-[#6D90B4]`}
                        />
                    </div>
                    {skillName && <div className='absolute inset-y-0 cursor-pointer right-0 pr-3 flex items-center' onClick={resetDebouncedValue}>
                        <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Close.svg?updatedAt=1742903383647" width={25} height={25} alt="" />
                    </div>}
                </div>
            </form>
        </div>
    )
}

export default SearchSkills